import { create } from 'zustand';
import { supabase } from '@/lib/supabase/client';

interface Experience {
  id: string;
  title: string;
  description: string;
  creator_id: string;
  creator?: any;
  category?: any;
  media?: any[];
  [key: string]: any;
}

interface ExperiencesState {
  experiences: Experience[];
  loading: boolean;
  error: string | null;
  
  // Actions
  fetchExperiences: () => Promise<void>;
  clearError: () => void;
  reset: () => void;
}

export const useExperiencesStore = create<ExperiencesState>((set) => ({
  experiences: [],
  loading: false,
  error: null,

  fetchExperiences: async () => {
    try {
      set({ loading: true, error: null });
      
      const { data, error } = await supabase
        .from('experiences')
        .select(`
          *,
          creator:creator_id (
            id,
            full_name,
            bio,
            profile_image,
            creator_profiles(*)
          ),
          category:categories(*),
          media:experience_media (
            url,
            type,
            order_index
          )
        `)
        .order('created_at', { ascending: false });

      if (error) throw error;

      // Process the data to unify creator_profile/creator_profiles naming
      const processedData = data?.map(exp => {
        if (exp.creator && Array.isArray(exp.creator.creator_profiles) && exp.creator.creator_profiles.length > 0) {
          // Map the first creator_profiles entry to creator_profile for compatibility
          return {
            ...exp,
            creator: {
              ...exp.creator,
              creator_profile: exp.creator.creator_profiles[0] || null
            }
          };
        }
        return exp;
      }) || [];

      set({ 
        experiences: processedData,
        loading: false,
        error: null
      });
    } catch (error) {
      console.error('Failed to fetch experiences:', error);
      set({ 
        loading: false,
        error: error instanceof Error ? error.message : 'Failed to fetch experiences'
      });
    }
  },

  clearError: () => set({ error: null }),
  
  reset: () => set({
    experiences: [],
    loading: false,
    error: null
  })
})); 